import React from "react";
import { createRoot } from "react-dom/client";
import "./common/styles/base.css";
import "./common/styles/variables.css";
import { App } from "./domain/App";
import { BrowserRouter as Router } from "react-router-dom";

const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);
  root.render(
    <Router>
      <App />
    </Router>,
  );
} else {
  console.error(
    'Root container not found. Make sure the element with id "root" exists in your HTML.',
  );
}
